module.exports = __webpack_public_path__ + "img/title3.32b898a3.png";